$(document).ready(function() {
    $('.column label').each(function() {
        var labelText = $(this).text();
        $(this).hide();
        $(this).next("input").attr("placeholder", labelText);
        $(this).next("textarea").attr("placeholder", labelText);
        // $(this).siblings(".custom-select").find(".text-start").text(labelText);
    });

    $('.cmscollection a').each(function() {
        var href = $(this).attr('href');
        var currentUrl = window.location.href;
        var hrefPage = href.split('/').pop();
        var currentUrlSplit  = currentUrl.split('/').pop();
        if (hrefPage === currentUrlSplit) {
            $(this).addClass('active'); // Add class if href matches window URL
        } else {
            $(this).removeClass('active'); // Remove class if href does not match window URL
        } 
    });

});